import Instance from '../../../../Axios';

// New Actions for the app

const GetTipoParceiro = () => async (dispatch) => {
  await Instance()
    .get(`/backend/tiposParceiros`)
    .then(({ data }) => {
      dispatch({ type: 'GET_TIPO_PARCEIRO', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTipoParceiro;
